import React, { useState } from "react";
import { IoMdSend } from "react-icons/io";
import { IoCloseOutline } from "react-icons/io5";
import { FaWhatsapp } from "react-icons/fa";
import styles from "./WhatsappButton.module.css";

const WhatsAppButton = () => {
  const phoneNumber = "+5930980202185";
  const [message, setMessage] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const handleSendMessage = () => {
    if (message.trim()) {
      const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
      window.open(whatsappUrl, "_blank");
      setMessage("");
      setIsOpen(false);
    }
  };

  return (
    <div className={styles.container}>
      <button onClick={() => setIsOpen(!isOpen)}
        className={`${styles.whatsappBtn} ${isOpen ? styles.rotate : "60"}`}>
          {isOpen ? (
            <IoCloseOutline className={styles.icon} /> // Muestra la "X" cuando el modal está abierto
          ) : (
            <FaWhatsapp className={styles.icon} /> // Muestra el ícono de WhatsApp cuando el modal está cerrado
          )}
      </button>
      
      {isOpen && (
        <div className={styles.modal}>
          <input
            required
            className={styles.textarea}
            placeholder="Hola escribe tu mensaje..."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
          <button onClick={handleSendMessage} className={styles.sendButton}>
            <IoMdSend size={30} />
          </button>
        </div>
      )}
    </div>
  );
};

export default WhatsAppButton;
